import { gql } from "@apollo/client"

export const REQUEST_PASSWORD_RESET = gql`
  mutation ResetPassword($email: String!) {
    requestPasswordReset(email: $email)
  }
`
